import React from 'react';
import {Site} from "./site";
import {useAsync} from "react-use";
import AppRouters from "settings/app-routers";
import http from 'service/api';
import {Api} from "settings/index";
import clsx from "clsx";

import finger from './finger.svg';

import styles from './sites.module.scss';

export const Sites = () => {
    const {error, loading, value} = useAsync(async () => {
        return await http.get(Api.getNodeExtraInfo);
    }, []);

    const urls = value?.data?.data?.url_apps;

    return (
        <div className={styles.container}>
            <div className={styles.headerContainer}>
                <h1>¿Estás listo para comprar tu reporte?</h1>
                <a href={AppRouters.newReport}
                   className={clsx("btn btn-outline-primary form-control btn-outline", styles.btn)}>
                    <span>Solicitar Reporte</span>
                </a>
            </div>
            <h1 className={styles.sitesTitle}>Visita nuestras aplicaciones</h1>
            <div className={styles.sitesContainer}>
                {
                    loading
                        ? <span/>
                        : <>
                            <Site
                                className={styles.idaiContainer}
                                href={urls?.idai}
                                title="!Ahorra tiempo y esfuerzo!"
                                subTitle="Solicita tu cotización personalizada."
                                message={
                                    <p>
                                        <strong>ID AUTO INSCRIPCIÓN</strong>,
                                        gestiona los trámites de vehículos nuevos. Todo el proceso completamente online.
                                    </p>
                                }/>

                            <Site
                                className={styles.walletContainer}
                                href={urls?.idaw}
                                title="!Ahora puedes!"
                                subTitle="Portar tu documentación vehicular y acceder con un solo click."
                                message={
                                    <p>
                                        <strong>ID AUTO WALLET</strong>,
                                        visualiza y gestiona la documentación de tu vehículo de forma fácil y sencilla.
                                    </p>
                                }>
                                <img src={finger} alt="finger" className={styles.finger}/>
                            </Site>
                        </>
                }
            </div>
        </div>
    );
};

Sites.propTypes = {}

Sites.defaultProps = {}

export default React.memo(Sites);
